import { PaginationRequestType } from '../../types/paginationRequestType';
import { ACADEMIC_STRUCTURE } from '../endpoints';
import request from '../request';

export type FacultyListItem = {
  id: number;
  name: string;
  code: string;
  description?: string | null;
};

export type FacultyItemBody = {
  id?: number;
  name: string;
  code: string;
  description?: string | null;
};

export type FacultyListResponse = PaginationRequestType<FacultyListItem>;

export const getFacultiesRequest = (items: number = 10, page: number = 0) => {
  return request<FacultyListResponse>(`${ACADEMIC_STRUCTURE.FACULTIES}`, {
    params: { items_per_page: items, page },
  });
};

export const getAllFacultiesRequest = () => {
  return request<FacultyListItem[]>(`${ACADEMIC_STRUCTURE.FACULTY_ALL}`);
};

export const saveFacultyRequest = (data: FacultyItemBody) => {
  const isEdit = !!data.id;
  return request<FacultyListItem>(
    `${ACADEMIC_STRUCTURE.FACULTIES}/${isEdit ? data.id : ''}`,
    {
      method: isEdit ? 'put' : 'post',
      data,
    },
  );
};

export const deleteFacultyRequest = (id: number) => {
  return request(`${ACADEMIC_STRUCTURE.FACULTIES}/${id}`, {
    method: 'delete',
  });
};

export const getFacultyRelatedSchoolsRequest = (id: number) => {
  return request<{ id: number; name: string }[]>(
    `${ACADEMIC_STRUCTURE.FACULTIES}/${id}/schools`,
  );
};
